import { Box, Button, Container, Group, Paper } from "@mantine/core";
import type { ReactNode } from "react";
import { useSupabase } from "@how/app-kit";
import { ShellBrand } from "@how/ui";

/**
 * The staff address's own page frame when no church is in the path (the member-only page, no access, the My schedule
 * forward):
 * the HoW brand, a way to sign out, and the content in a readable column. `staffChurchHref` links back to the
 * person's one staff church (ADR 0068) as a plain link, a full page load; null or absent shows no link.
 */
export function DoorLayout({
  children,
  staffChurchHref = null,
}: {
  children: ReactNode;
  staffChurchHref?: string | null;
}) {
  const supabase = useSupabase();
  return (
    <Container size="sm" py="xl" px="md">
      {/* On a phone the actions wrap under the brand rather than squeezing it (its badge truncated at 390 px). */}
      <Group justify="space-between" align="center" mb="xl" wrap="wrap" gap="xs">
        <Box style={{ flexShrink: 0 }}>
          <ShellBrand surface="Staff" />
        </Box>
        <Group gap="xs" wrap="nowrap" ml="auto">
          {staffChurchHref === null ? null : (
            <Button component="a" href={staffChurchHref} variant="subtle">
              Open the staff dashboard
            </Button>
          )}
          <Button
            variant="subtle"
            color="gray"
            onClick={() => {
              void supabase.auth.signOut();
            }}
          >
            Sign out
          </Button>
        </Group>
      </Group>
      <Paper withBorder radius="md" p="lg">
        {children}
      </Paper>
    </Container>
  );
}
